import styled from 'vue-styled-components';

// disabled 폼 엘리먼트는 브라우저가 마우스 이벤트를 억제해 툴팁 정렬이
// 불안정해지므로, hover 이벤트는 이 span이 받고 자식에게는 흘리지 않는다.
const TooltipTarget = styled('span', { block: Boolean })`
    display: inline-flex;
    width: ${({ block }) => (block ? '100%' : 'auto')};

    /* 자식이 pointer-events: none이라 커서도 이 span이 결정한다 */
    cursor: not-allowed;

    & > * {
        pointer-events: none;
    }
`;

/**
 * 권한이 없어 disabled 처리된 UI에 안내 툴팁을 붙이는 래퍼.
 * visible이 false면 children을 그대로 렌더하고, 아니면 툴팁 타겟 span으로 감싼다.
 * 자식의 disabled 스타일링은 호출부 책임.
 */
export default {
    name: 'PermissionTooltip',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        placement: {
            type: String,
            default: 'top',
        },
        // 클릭 가능한 부모(리스트 row 등) 안에서 쓸 때, disabled 영역 클릭이
        // 부모 onClick으로 흘러가지 않도록 차단
        stopClickPropagation: {
            type: Boolean,
            default: false,
        },
        // absolute 배치된 래퍼 등 타겟 span이 부모를 꽉 채워야 할 때 사용
        block: {
            type: Boolean,
            default: false,
        },
    },
    render() {
        const children = this.$slots.default || [];

        if (!this.visible) {
            return children[0];
        }

        return (
            <a-tooltip
                placement={this.placement}
                mouseLeaveDelay={0}
                getPopupContainer={R.always(document.body)}
                autoAdjustOverflow={false}
                overlayClassName="adriel-permission-tooltip"
            >
                <div class="adriel-tooltip-slot-content" slot="title">
                    {this.$t('COMMON.permission_denied_tooltip')}
                </div>
                <TooltipTarget
                    block={this.block}
                    onClick={(e) => {
                        if (this.stopClickPropagation) {
                            e.stopPropagation();
                        }
                    }}
                >
                    {children}
                </TooltipTarget>
            </a-tooltip>
        );
    },
};
